import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import AuthoringPage from "../AuthoringPage";
import CapabilityOverridesForm from "./CapabilityOverridesForm";
import { draftOfQuery } from "./overrideDrafts";

/**
 * `/workflows/new/capability-overrides`: a new capability overrides item (CAP-4). The go-live
 * dialog opens it with the capability it could not find already filled in.
 */
export default function NewCapabilityOverridesPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [initial] = useState(() => draftOfQuery(searchParams));
  return (
    <AuthoringPage title={t("authoring.capabilities.newTitle")} intro={t("authoring.capabilities.intro")}>
      {(projectId) => <CapabilityOverridesForm projectId={projectId} base={null} initial={initial} />}
    </AuthoringPage>
  );
}
